"use client";

import { useState } from "react";

interface HideableEmailProps {
  email: string;
}

export const HideableEmail = ({ email }: HideableEmailProps) => {
  const [showEmail, setShowEmail] = useState(false);

  return showEmail ? (
    <strong className="text-slate-900 dark:text-white">{email}</strong>
  ) : (
    <strong
      onClick={() => setShowEmail(true)}
      className="cursor-pointer text-brand-600 hover:underline"
    >
      [kliknij, aby pokazać adres email]
    </strong>
  );
};
